function ArrowUp() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      version="1.1"
      viewBox="0 0 600 600"
    >
      <g
        strokeWidth="1.051"
        transform="matrix(.95173 0 0 .95116 13.901 12.169)"
      >
        <path
          fill="#000"
          strokeLinecap="round"
          d="M573.734 237.531a42.016 42.067 0 00-13.715-29.123L328.862-1.862a42.016 42.067 0 00-.051-.035 42.016 42.067 0 00-28.203-11.547 42.016 42.067 0 00-28.2 11.545 42.016 42.067 0 00-.055.037L41.196 208.408a42.016 42.067 0 00-2.845 59.424 42.016 42.067 0 0059.351 2.848l160.89-146.352V576.6a42.016 42.067 0 0042.016 42.066 42.016 42.067 0 0042.016-42.066V124.328L503.51 270.68a42.016 42.067 0 0059.353-2.848 42.016 42.067 0 0010.87-30.3z"
          color="#000"
        ></path>
      </g>
    </svg>
  );
}

export default ArrowUp;
